import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class RefundAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "request";

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getNew(payload) {
    return;
  }

  /**
   * Thêm mới
   */
  insert(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload.Entity,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Xóa
   */
  delete(payload) {
    let request = {
      url: this.getAPIUrl() + "/" + payload.Entity[0].id,
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }

  /**
   * sửa user
   */
  updateRefund(payload, id) {
    let request = {
      url: [this.getAPIUrl(), "refund", id].join("/"),
      data: payload,
    };
    console.log([this.getAPIUrl(), "refund", id].join("/"));
    return httpClient.putAsync(request, true);
  }
  //      /**
  //  * Xóa
  //  */
  //  delete(payload) {
  //     let request = {
  //         url: this.getAPIUrl() + "/" + payload.Entity[0].id,
  //         data: payload
  //     };
  //     return httpClient.deleteAsync(request, true);
  // }
}

export default new RefundAPI();
